export default __webpack_public_path__ + "static/media/include_2@2x.cf5b23a9.jpg";